import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB4-V2-U1-P11-E1',
    exerciseKey: 'img/FriendsPlus/Page11/E1/Key/answerKey.png',
    audio: '',
    video: '',
    recorder: true,
    component: D1,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page11/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page11/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page11/E1/3.jpg', input: true, answer: "box" },
        { url: 'img/FriendsPlus/Page11/E1/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page11/E1/5.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page11/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page11/E1/7.jpg', input: true, answer: "rug" },
        { url: 'img/FriendsPlus/Page11/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page11/E1/9.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E1/10.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB4-V2-U1-P11-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page11/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page11/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page11/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/3.jpg', input: true, answer: "rug" },
        { url: 'img/FriendsPlus/Page11/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/5.jpg', input: true, answer: "rug" },
        { url: 'img/FriendsPlus/Page11/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/7.jpg', input: true, answer: "rug" },
        { url: 'img/FriendsPlus/Page11/E2/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page11/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/10.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page11/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/13.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/15.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/17.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E2/18.jpg' },

      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page11/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/20.jpg', input: true, answer: "pot" },
        { url: 'img/FriendsPlus/Page11/E2/21.jpg' },
      ],
      [
        // 6
        { url: 'img/FriendsPlus/Page11/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/23.jpg', input: true, answer: "pot" },
        { url: 'img/FriendsPlus/Page11/E2/24.jpg' },
      ],
      [
        // 7
        { url: 'img/FriendsPlus/Page11/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/26.jpg', input: true, answer: "fox" },
        { url: 'img/FriendsPlus/Page11/E2/27.jpg' },
      ],
      [
        // 8
        { url: 'img/FriendsPlus/Page11/E2/28.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/29.jpg', input: true, answer: "box" },
        { url: 'img/FriendsPlus/Page11/E2/30.jpg' },
      ]
    ],
  },

  3: { // Exercise num
    unit: 'Unit 1',
    id: 'WB4-V2-U1-P11-E3',
    audio: 'img/FriendsPlus/Page11/Audio/audio-e3-p11.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page11/E3/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column 1
        { url: 'img/FriendsPlus/Page11/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/1a.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/tieude-e3-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E3/1b.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page11/E3/1c.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page11/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/5.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/6.jpg', },
        { url: 'img/FriendsPlus/Page11/E3/7.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page11/E3/8.jpg', },
      ],
      [
        // Column 3
        { url: 'img/FriendsPlus/Page11/E3/9.jpg' },
      ],
      [
        // Column 4
        { url: 'img/FriendsPlus/Page11/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/11.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/12.jpg', },
        { url: 'img/FriendsPlus/Page11/E3/13.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page11/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/15.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/17.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page11/E3/18.jpg' },
      ],
      [
        // Column 5
        { url: 'img/FriendsPlus/Page11/E3/19.jpg' },
      ],
    ],
  },
}

export default json;